import { graphql } from '@search/gql-client/src/useGql';

export const TrackSearchMutation = graphql`
    mutation TrackSearchMutation($filters: ProfessionalSearchInput) {
        trackSearch(filters: $filters) {
            success
        }
    }
`;
